import styled from 'styled-components';
import MuiAlert from '@mui/material/Alert';

export const Alert = styled(MuiAlert)`
  &.MuiPaper-root {
    display: inline-flex;
  }
`;
